import Component from 'cartware-component';
import { throttle } from 'lodash';

/* eslint-disable */
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["domready"] }] */
export default class extends Component {
  domready() {
    $('.products-list').on('DOMSubtreeModified', throttle(this.decode_product_links, 50), false);
    this.decode_product_links();
  }

  decode_product_links() {
    $('.product-image-area').each(function() {
      const area = $(this);
      // area.unbind().on('click', function(e) {
      //   $(location).attr('href', $(this).find('.product-name a').attr('href'));
      // });
      area.find('.addtocart[data-href], .addtowishlist[data-href], .addtocompare[data-href]').each(function() {
        $(this).replaceWith('<a href="' + atob($(this).data('href')) + '" title="' + $(this).attr('title') + '" class="' + $(this).attr('class') + '">' + $(this).html() + '</a>');
      });
      area.find('.addtocart').on('click', function(event){
        event.preventDefault;
        eval($(this).attr('href'));
        $(this).attr('href', '');
        return false;
      });
    });
  }
}
